export const PDF_DOCUMENT_STYLES = `
    @page {
        size: A4;
        margin: 14mm 14mm 16mm 14mm;
    }
    * {
        box-sizing: border-box;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
    }
    body {
        font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        color: #0f172a;
        background: #ffffff;
        line-height: 1.6;
        margin: 0;
        padding: 0;
        font-size: 13px;
        -webkit-font-smoothing: antialiased;
    }
    .top-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #0284c7;
        padding-bottom: 8px;
        margin-bottom: 18px;
    }
    .brand-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .brand-badge {
        background: linear-gradient(135deg, #0284c7, #0f766e);
        color: #ffffff;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.08em;
        padding: 3px 8px;
        border-radius: 5px;
        text-transform: uppercase;
    }
    .brand-title {
        font-size: 13px;
        font-weight: 800;
        letter-spacing: 0.04em;
        color: #0f172a;
    }
    .brand-sub {
        font-size: 11px;
        font-weight: 600;
        color: #64748b;
    }
    .header-meta {
        text-align: right;
        font-size: 10px;
        color: #64748b;
        font-weight: 500;
    }
    .header-meta .doc-id {
        font-family: 'JetBrains Mono', monospace;
        font-weight: 700;
        color: #0284c7;
        background: #f0f9ff;
        border: 1px solid #bae6fd;
        padding: 2px 6px;
        border-radius: 4px;
        display: inline-block;
        margin-bottom: 2px;
    }
    .hero-section {
        margin-bottom: 16px;
    }
    .cat-badge {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 3px 10px;
        border-radius: 20px;
        font-size: 10.5px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        color: #1d4ed8;
        margin-bottom: 8px;
    }
    .hero-title {
        font-size: 24px;
        font-weight: 800;
        color: #0f172a;
        letter-spacing: -0.025em;
        line-height: 1.25;
        margin: 0 0 8px 0;
    }
    .hero-title em {
        font-weight: 400;
        font-style: italic;
        color: #475569;
    }
    .tags-row {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 14px;
    }
    .tag-pill {
        font-size: 10px;
        font-weight: 600;
        color: #475569;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        padding: 2px 7px;
        border-radius: 4px;
    }
    .summary-card {
        background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1px solid #cbd5e1;
        border-left: 4px solid #0284c7;
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 14px;
        page-break-inside: avoid;
    }
    .summary-header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 10.5px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #0369a1;
        margin-bottom: 5px;
    }
    .summary-text {
        font-size: 13px;
        line-height: 1.6;
        color: #1e293b;
        font-weight: 500;
        margin: 0;
    }
    .rule-card {
        background: #090d16;
        border: 1px solid #1e293b;
        border-radius: 8px;
        padding: 12px 16px;
        margin-bottom: 18px;
        page-break-inside: avoid;
        box-shadow: 0 2px 4px rgba(0,0,0,0.04);
    }
    .rule-header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #38bdf8;
        margin-bottom: 6px;
    }
    .rule-code {
        font-family: 'JetBrains Mono', Consolas, monospace;
        font-size: 12px;
        font-weight: 600;
        color: #4ade80;
        line-height: 1.5;
        word-break: break-word;
    }
    .section-main-heading {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #0f172a;
        margin: 0 0 10px 0;
        padding-bottom: 6px;
        border-bottom: 1.5px solid #e2e8f0;
    }
    .concept-card {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 9px;
        padding: 12px 16px;
        margin-bottom: 12px;
        page-break-inside: avoid;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }
    .concept-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        padding-bottom: 7px;
        border-bottom: 1px solid #f1f5f9;
    }
    .concept-badge {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 11px;
        font-weight: 800;
        flex-shrink: 0;
    }
    .concept-title {
        font-size: 13.5px;
        font-weight: 800;
        color: #0f172a;
        letter-spacing: -0.01em;
    }
    .concept-title em {
        font-weight: 400;
        font-style: italic;
        color: #64748b;
    }
    .concept-body {
        font-size: 12.5px;
        color: #334155;
        line-height: 1.65;
    }
    .concept-paragraph {
        margin: 0 0 8px 0;
        font-size: 12.5px;
        line-height: 1.65;
        color: #334155;
    }
    .concept-paragraph:last-child {
        margin-bottom: 0;
    }
    .formula-pill {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 5px 12px;
        border-radius: 20px;
        background: #ecfdf5;
        border: 1.5px solid #a7f3d0;
        color: #065f46;
        font-size: 12px;
        font-weight: 700;
        margin: 6px 0 10px 0;
    }
    .confluence-card {
        background: #fffdf5;
        border: 1.5px solid #fde68a;
        border-radius: 8px;
        padding: 10px 14px;
        margin: 8px 0;
        page-break-inside: avoid;
    }
    .confluence-header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 11px;
        font-weight: 800;
        color: #b45309;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-bottom: 8px;
    }
    .confluence-row {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        margin-bottom: 6px;
        color: #1e293b;
    }
    .confluence-row:last-child {
        margin-bottom: 0;
    }
    .conf-pill {
        font-size: 10.5px;
        font-weight: 700;
        padding: 2px 7px;
        border-radius: 5px;
        white-space: nowrap;
    }
    .conf-blue {
        background: #e0f2fe;
        color: #0369a1;
        border: 1px solid #bae6fd;
    }
    .conf-purple {
        background: #f3e8ff;
        color: #6b21a8;
        border: 1px solid #e9d5ff;
    }
    .conf-gold {
        background: #fef3c7;
        color: #92400e;
        border: 1px solid #fde68a;
    }
    .conf-arrow {
        color: #94a3b8;
        font-weight: 700;
    }
    .conf-highlight {
        background: #fefce8;
        padding: 5px 8px;
        border-radius: 6px;
        border: 1px dashed #facc15;
        margin-top: 4px;
    }
    .conf-gold-text {
        font-weight: 700;
        color: #854d0e;
    }
    .pivot-card {
        border-radius: 7px;
        padding: 10px 14px;
        margin: 8px 0;
        page-break-inside: avoid;
    }
    .pivot-green-card {
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
    }
    .pivot-blue-card {
        background: #f0f9ff;
        border: 1px solid #bae6fd;
    }
    .pivot-purple-card {
        background: #faf5ff;
        border: 1px solid #e9d5ff;
    }
    .pivot-tag {
        font-size: 10.5px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 4px;
        display: inline-block;
        margin-bottom: 6px;
    }
    .pivot-tag-green {
        background: #dcfce7;
        color: #15803d;
    }
    .pivot-tag-blue {
        background: #e0f2fe;
        color: #0369a1;
    }
    .pivot-tag-purple {
        background: #f3e8ff;
        color: #7e22ce;
    }
    .pivot-desc {
        font-size: 12px;
        margin: 0 0 6px 0;
        color: #1e293b;
    }
    .invalidation-alert {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        background: #fef2f2;
        border: 1px solid #fecaca;
        border-left: 3px solid #ef4444;
        border-radius: 6px;
        padding: 7px 10px;
        font-size: 11.5px;
        line-height: 1.5;
        color: #991b1b;
        margin-top: 6px;
    }
    .step-card {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 9px 12px;
        margin-bottom: 8px;
        page-break-inside: avoid;
    }
    .step-badge {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        background: #0284c7;
        color: #ffffff;
        font-size: 10.5px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-top: 2px;
    }
    .step-title {
        font-weight: 700;
        color: #0f172a;
        font-size: 12px;
        margin-bottom: 2px;
    }
    .step-body {
        font-size: 12px;
        color: #334155;
        line-height: 1.55;
    }
    .styled-list {
        margin: 6px 0 10px 0;
        padding-left: 20px;
        font-size: 12.5px;
        color: #334155;
        line-height: 1.6;
    }
    .styled-list li {
        margin-bottom: 4px;
    }
    .styled-list li strong {
        color: #0f172a;
    }
    .inline-code {
        font-family: 'JetBrains Mono', Consolas, monospace;
        font-size: 11px;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        padding: 1px 5px;
        border-radius: 4px;
        color: #0284c7;
        font-weight: 600;
    }
    .math-term {
        font-family: 'JetBrains Mono', Consolas, monospace;
        font-size: 11px;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        padding: 1px 4px;
        border-radius: 3px;
        color: #0369a1;
        font-weight: 600;
    }
    .math-box {
        margin: 8px 0;
        padding: 8px 14px;
        background: #f8fafc;
        border: 1px dashed #cbd5e1;
        border-radius: 6px;
        text-align: center;
        font-family: 'JetBrains Mono', monospace;
        font-size: 12px;
        color: #0369a1;
    }
    .illustration-card {
        background: #090d16;
        border: 1px solid #1e293b;
        border-radius: 10px;
        padding: 14px;
        margin: 14px 0;
        page-break-inside: avoid;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08);
    }
    .illustration-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #1e293b;
        flex-wrap: wrap;
        gap: 8px;
    }
    .illustration-title-group {
        display: flex;
        align-items: center;
        gap: 7px;
    }
    .ill-badge {
        font-size: 14px;
    }
    .ill-title {
        font-size: 12.5px;
        font-weight: 700;
        color: #f1f5f9;
    }
    .ill-caption {
        font-size: 11px;
        font-weight: 600;
        color: #94a3b8;
        background: #1e293b;
        padding: 2px 8px;
        border-radius: 4px;
        border: 1px solid #334155;
    }
    .illustration-body {
        text-align: center;
    }
    .illustration-img {
        max-width: 100%;
        max-height: 380px;
        border-radius: 7px;
        border: 1px solid #334155;
        background: #020617;
    }
    .strategy-card {
        background: #fffdf5;
        border: 1.5px solid #fde68a;
        border-radius: 9px;
        padding: 12px 16px;
        margin-top: 14px;
        page-break-inside: avoid;
    }
    .strategy-header {
        display: flex;
        align-items: center;
        gap: 7px;
        font-size: 11px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #b45309;
        margin-bottom: 8px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #fde68a;
    }
    .strategy-body {
        font-size: 12px;
        line-height: 1.6;
        color: #78350f;
    }
    .strategy-paragraph {
        margin: 0 0 6px 0;
    }
    .strategy-step {
        display: flex;
        align-items: flex-start;
        gap: 9px;
        margin-bottom: 6px;
    }
    .strategy-step-badge {
        width: 18px;
        height: 18px;
        border-radius: 5px;
        background: #d97706;
        color: #ffffff;
        font-size: 10px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-top: 1px;
    }
    .footer-bar {
        margin-top: 24px;
        padding-top: 10px;
        border-top: 1px solid #e2e8f0;
        display: flex;
        justify-content: space-between;
        font-size: 9.5px;
        color: #94a3b8;
        font-weight: 500;
    }

    /* Table styles for PDF */
    .pdf-table-wrapper {
        margin: 14px 0;
        overflow-x: auto;
        page-break-inside: avoid;
    }
    .pdf-doc-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 11px;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
        overflow: hidden;
    }
    .pdf-doc-table th {
        background: #f1f5f9;
        padding: 7px 10px;
        text-align: left;
        font-weight: 700;
        color: #0f172a;
        border-bottom: 2px solid #94a3b8;
        border-right: 1px solid #cbd5e1;
    }
    .pdf-doc-table th:last-child {
        border-right: none;
    }
    .pdf-doc-table td {
        padding: 6px 10px;
        color: #334155;
        border-bottom: 1px solid #e2e8f0;
        border-right: 1px solid #e2e8f0;
        vertical-align: top;
    }
    .pdf-doc-table td:last-child {
        border-right: none;
    }
    .pdf-doc-table tr:nth-child(even) {
        background: #f8fafc;
    }
    .pdf-doc-table tr:last-child td {
        border-bottom: none;
    }
    .pdf-doc-table td em, .pdf-doc-table th em {
        font-style: italic;
        font-weight: 400;
        color: #475569;
    }

    /* Multi-document Pagination & Cover styles */
    .doc-section-page {
        page-break-after: always;
        break-after: page;
        padding-bottom: 14px;
    }
    .doc-section-page:last-child {
        page-break-after: auto;
        break-after: auto;
    }
    .cover-page {
        page-break-after: always;
        break-after: page;
        min-height: 94vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 16px 0 10px 0;
    }
    .cover-brand-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #0284c7;
        padding-bottom: 10px;
    }
    .cover-badge {
        background: linear-gradient(135deg, #0284c7, #0f766e);
        color: #ffffff;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.1em;
        padding: 4px 10px;
        border-radius: 6px;
        text-transform: uppercase;
    }
    .cover-date {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        font-family: 'JetBrains Mono', monospace;
    }
    .cover-main {
        margin: 20px 0 16px 0;
    }
    .cover-title {
        font-size: 28px;
        font-weight: 800;
        color: #0f172a;
        letter-spacing: -0.03em;
        margin: 0 0 6px 0;
        line-height: 1.15;
    }
    .cover-subtitle {
        font-size: 16px;
        font-weight: 600;
        color: #0284c7;
        margin: 0 0 12px 0;
    }
    .cover-divider {
        width: 50px;
        height: 4px;
        background: #0284c7;
        border-radius: 2px;
        margin-bottom: 12px;
    }
    .cover-desc {
        font-size: 12px;
        color: #475569;
        max-width: 650px;
        line-height: 1.6;
        margin: 0 0 16px 0;
    }
    .cover-stats-grid {
        display: flex;
        gap: 12px;
        margin-bottom: 16px;
    }
    .cover-stat-card {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 8px 16px;
        display: flex;
        flex-direction: column;
    }
    .cover-stat-val {
        font-size: 18px;
        font-weight: 800;
        color: #0f172a;
        font-family: 'JetBrains Mono', monospace;
    }
    .cover-stat-lbl {
        font-size: 9.5px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }
    .toc-container {
        background: #f8fafc;
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        padding: 14px 18px;
        margin-bottom: 16px;
        page-break-inside: avoid;
    }
    .toc-title {
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #0f172a;
        border-bottom: 1.5px solid #cbd5e1;
        padding-bottom: 6px;
        margin-bottom: 10px;
    }
    .toc-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px 20px;
    }
    .toc-category-name {
        font-size: 10.5px;
        font-weight: 800;
        color: #0369a1;
        margin-bottom: 4px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }
    .toc-list {
        margin: 0;
        padding-left: 0;
        list-style: none;
    }
    .toc-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10.5px;
        padding: 2.5px 0;
        border-bottom: 1px dotted #e2e8f0;
        color: #334155;
    }
    .toc-term-name {
        font-weight: 600;
    }
    .toc-term-id {
        font-family: 'JetBrains Mono', monospace;
        font-size: 9px;
        color: #94a3b8;
    }
    .cover-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 9px;
        color: #94a3b8;
        border-top: 1px solid #e2e8f0;
        padding-top: 8px;
        font-weight: 600;
    }

    @media print {
        body {
            background: #ffffff !important;
        }
        .doc-section-page {
            page-break-after: always !important;
            break-after: page !important;
        }
        .cover-page {
            page-break-after: always !important;
            break-after: page !important;
        }
        .concept-card, .summary-card, .rule-card, .strategy-card, .pdf-table-wrapper, .illustration-card, .toc-container {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
        }
    }
`;
